var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00012 6.20052C1.00012 4.38017 1.00012 3.46999 1.36343 2.77471C1.68301 2.16312 2.19295 1.66588 2.82015 1.35426C3.53319 1 4.46661 1 6.33346 1H15.6668C17.5336 1 18.4671 1 19.1801 1.35426C19.8073 1.66588 20.3172 2.16312 20.6368 2.77471C21.0001 3.46999 21.0001 4.38017 21.0001 6.20052V12.0511C21.0001 13.8715 21.0001 14.7816 20.6368 15.4769C20.3172 16.0885 19.8073 16.5857 19.1801 16.8974C18.4671 17.2516 17.5336 17.2516 15.6668 17.2516H12.871C12.1776 17.2516 11.8309 17.2516 11.4993 17.318C11.205 17.3769 10.9203 17.4743 10.6529 17.6075C10.3514 17.7577 10.0807 17.9689 9.53925 18.3912L6.88874 20.4588C6.42642 20.8195 6.19526 20.9998 6.00072 21C5.83153 21.0002 5.67148 20.9252 5.56593 20.7962C5.44457 20.648 5.44457 20.3593 5.44457 19.782V17.2516C4.41126 17.2516 3.89461 17.2516 3.47073 17.1409C2.32042 16.8403 1.42193 15.9642 1.1137 14.8425C1.00012 14.4292 1.00012 13.9254 1.00012 12.9179V6.20052Z",
    stroke: "#BD23DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessage);
export default __webpack_public_path__ + "static/media/new_message.08330d314aae57f37a95808c0e02e300.svg";
export { ForwardRef as ReactComponent };